import React from 'react';
import { withFormsy } from 'formsy-react';
import { FormControl, MenuItem, Select, styled } from '@mui/material';

import useSettings from '../hooks/useSettings';

interface FilterItemOperatorSelectFieldProps {
	name: string;
	operators: string[];
	value: string;
	setValue: React.Dispatch<React.SetStateAction<string>>;
	sendChange: (newOperator?: string) => void;
	disabled?: boolean;
}

const OperatorSelect = styled(Select)(({ theme }) => ({
	'& > .MuiSelect-select': {
		paddingTop: 12,
		paddingBottom: 12
	}
}));

function FilterItemOperatorSelectField({
	name,
	operators,
	value,
	setValue,
	sendChange,
	disabled
}: FilterItemOperatorSelectFieldProps) {
	const { t } = useSettings();

	function handleChange(event) {
		sendChange(event.target.value);
		setValue(event.target.value);
	}

	return (
		<FormControl fullWidth>
			<OperatorSelect
				name={name}
				variant="outlined"
				size="small"
				fullWidth
				value={value}
				onChange={handleChange}
				disabled={disabled}
			>
				{operators.map(clause => (
					<MenuItem key={clause} value={clause}>
						{t(`OPERATOR_${clause}`)}
					</MenuItem>
				))}
			</OperatorSelect>
		</FormControl>
	);
}

export default React.memo(withFormsy(FilterItemOperatorSelectField));
